<div #divSpinner class="cargando" [style.display]="cargando ? '' : 'none'">
    <mat-spinner style="margin:0 auto; margin-top: 15%;"></mat-spinner>
</div>

<div class="customers">
    <div class="card">
        <div class="card-body" style="padding: 20px;">
            <div class="row">
                <div class="col-sm-6">
                    <p class="titulo-card-naranja">Ideario</p>
                </div>
                <div class="col-sm-6" style="text-align: right;">
                    <button type="button" class="btn btn-light btn-volver" style="background: #FF8685 0% 0% no-repeat padding-box;color: #FFEEEE;" (click)="guardarIdeario()" *ngIf="guardarEditar && !simulacion"> Guardar</button>
                    <button type="button" class="btn btn-light btn-volver" *ngIf="simulacion" (click)="volver2()"> Volver</button>
                    <button type="button" class="btn btn-light btn-volver" *ngIf="!simulacion" (click)="volver()"> Volver</button>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6" style="border-right: 1px solid #E8E8E8;">
                    <div class="row">
                        <div class="col-sm-6">

                        </div>
                        <div class="col-sm-6" style="text-align: right;">
                            <p style="margin-right: 10px;
                            font: normal normal bold 16px/20px Montserrat;
                            letter-spacing: 0px;
                            color: #3A445E;
                            text-transform: uppercase;
                            
                            opacity: 1;">Contexto Institucional</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <p style="text-align: left;font: normal normal bold 12px/19px Montserrat;letter-spacing: 0px; margin-left: 15px; color: #FF8685;text-transform: uppercase;opacity: 1;">Sello</p>
                        </div>
                    </div>
                    <div class="row" style="padding: 15px;">
                        <div class="col-sm-12" style="background: #F6F6F6 0% 0% no-repeat padding-box;border-radius: 10px;opacity: 1;padding: 15px;text-align: justify;">
                            <p>La Junta Nacional de Jardines Infantiles es una la institución del estado que otorga educación pública gratuita, inclusiva e integral para el nivel, en coherencia con los principios y valores declarados en las Bases Curriculares de la Educación Parvularia que “se basan en la convicción fundamental de que los seres humanos nacen libres e iguales en dignidad y derechos y que la perfectibilidad inherente a la naturaleza humana se despliega en procesos de autoafirmación personal y de búsqueda permanente de trascendencia. A la libertad que hace de cada individuo, persona y sujeto de derechos, le es intrínseca la capacidad de razonar, discernir, valorar y actuar de forma responsable”.</p>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12">
                            <p style="text-align: left;font: normal normal bold 12px/19px Montserrat;letter-spacing: 0px; margin-left: 15px;color: #FF8685;text-transform: uppercase;opacity: 1;">Visión</p>
                        </div>
                    </div>
                    <div class="row" style="padding: 15px;">
                        <div class="col-sm-12" style="background: #F6F6F6 0% 0% no-repeat padding-box;border-radius: 10px;opacity: 1;padding: 15px;text-align: justify;">
                            <p>Ser referente en educación inicial de calidad, donde niños y niñas son protagonistas de sus propios aprendizajes.</p>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12">
                            <p style="text-align: left;font: normal normal bold 12px/19px Montserrat;letter-spacing: 0px; margin-left: 15px;color: #FF8685;text-transform: uppercase;opacity: 1;">Misión</p>
                        </div>
                    </div>
                    <div class="row" style="padding: 15px;">
                        <div class="col-sm-12" style="background: #F6F6F6 0% 0% no-repeat padding-box;border-radius: 10px;opacity: 1;padding: 15px;text-align: justify;">
                            <p>Entregar Educación Parvularia de calidad y bienestar integral a niños y niñas preferentemente entre 0 y 4 años, priorizando a las familias con mayor vulnerabilidad socioeconómica, a través de una oferta programática diversa y pertinente a los contextos territoriales.</p>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12">
                            <p style="text-align: left;font: normal normal bold 12px/19px Montserrat;letter-spacing: 0px; margin-left: 15px;color: #FF8685;text-transform: uppercase;opacity: 1;">Valores</p>
                        </div>
                    </div>
                    <div class="row" style="padding: 15px;">
                        <div class="col-sm-12" style="background: #F6F6F6 0% 0% no-repeat padding-box;border-radius: 10px;opacity: 1;padding: 15px;text-align: justify;">
                            <p><b>Compromiso:</b> Comprender el impacto de nuestros roles y quehaceres en la institución para hacernos verdaderamente responsables de la calidad del servicio que entregamos. </p>
                                <br/>
                            <p><b>Respeto:</b> reconocer la dignidad de todas las personas, aceptando y valorando sus cualidades e intereses. </p>
                            <br/>
                                <p><b>Empatía:</b>Ser capaces de comprender las emociones y los sentimientos de los demás, reconociendo a las otras personas como iguales. </p>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12">
                            <p style="text-align: left;font: normal normal bold 12px/19px Montserrat;letter-spacing: 0px; margin-left: 15px;color: #FF8685;text-transform: uppercase;opacity: 1;">Definiciones y sentidos institucionales</p>
                        </div>
                    </div>
                    <div class="row" style="padding: 15px;">
                        <div class="col-sm-12" style="background: #F6F6F6 0% 0% no-repeat padding-box;border-radius: 10px;opacity: 1;padding: 15px;text-align: justify;">
                            <p>La Educación Parvularia como primer nivel del sistema educativo tiene como propósito favorecer una educación de calidad, oportuna y pertinente, que propicie aprendizajes relevantes y significativos en función del bienestar integral, el desarrollo pleno y la trascendencia de la niña y del niño como persona. Lo descrito debe darse en estrecha relación y complementación con la labor educativa de la familia, propiciando a la vez su continuidad en el sistema educativo y su contribución a la sociedad, en un marco de valores nacionalmente compartidos que reconoce a niñas y niños en su calidad de sujetos de derecho. De esta manera, la Educación Parvularia se concibe como un proceso participativo que se construye colectivamente con todos los actores de la comunidad educativa, promoviendo la reflexión personal y colectiva, resguardando el valor de la diversidad en pro de una sociedad más justa y democrática. </p>
                                <p>La Junta Nacional de Jardines infantiles sitúa a los niños y niñas al centro del proceso educativo, reconociendo sus derechos, características y particularidades, asumiendo la diversidad como un valor que guía una educación de calidad, desde este sentido demanda un proceso educativo que se centre en el reconocimiento de las diferencias individuales, lo cual está enmarcado en los referentes curriculares de la educación parvularia, como: las Bases Curriculares de Educación Parvularia, los Estándares Indicativos del Desempeño, Marco para la Buenas Enseñanza, Marco para el Buen Liderazgo y Propuesta Curricular Institucional. Si bien, estos documentos nos permiten realizar una ruta de proceso educativo que guían y orientan para entregar una educación parvularia de calidad., es necesario que las unidades educativas inicien la búsqueda y desarrollen una propuesta que autodetermine su sello curricular acorde a su contexto, impulsando la autonomía para establecer metodologías o enfoques pedagógicos de acuerdo a la realidad territorial en la que están insertos, permitiendo brindar educación de calidad, pertinente y situada. </p>
                                <p>Por su parte, los principios pedagógicos constituyen un conjunto de orientaciones centrales de teoría pedagógica avalados por la investigación, proveniente tanto de los paradigmas fundantes de la Educación Parvularia como de las construcciones teóricas que han surgido de la investigación del sector en las últimas décadas. </p>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12">
                            <p style="text-align: left;font: normal normal bold 12px/19px Montserrat;letter-spacing: 0px; margin-left: 15px;color: #FF8685;text-transform: uppercase;opacity: 1;">Perfiles</p>
                        </div>
                    </div>
                    <div class="row" style="padding: 15px;">
                        <div class="col-sm-12" style="background: #F6F6F6 0% 0% no-repeat padding-box;border-radius: 10px;opacity: 1;padding: 15px;text-align: justify;">
                            <p>Para la generación e implementación de lo declarado y comprometido en el Proyecto Educativo Institucional se requiere de un equipo comprometido que cuente con las competencias técnicas que posibiliten su quehacer y el cumplimiento de funciones que promuevan procesos educativos de calidad. Dichos equipos están comprometidas y comprometidos con los derechos y la formación de todos los niños y las niñas, involucrando en la acción de enseñar todos sus conocimientos, capacidades y valores para establecer una interrelación empática y sensible que hace distintiva e insustituible la tarea educativa en este nivel.</p>
                                <p>Aportando con lo mejor de sí en lo personal y profesional, desde un rol de garantes de derechos y corresponsabilidad en los procesos de enseñanza y aprendizaje y en el desarrollo y bienestar integral de las infancias. Para JUNJI, es vital relevancia la conformación de comunidades educativas, atendiendo a la construcción colaborativa, por ello se entenderá como equipos a: Director/a o Encargado/a, Educadoras/es de Párvulos, Técnicas/os en Educación Parvularia, Auxiliares de Servicios, Administrativas/os y Manipuladores/as de Alimentos.</p>
                        </div>
                    </div>

                </div>
                <div class="col-sm-6">
                    <div class="row">
                        <div class="col-sm-6">
                            <p style="text-align: left;
                            font: normal normal bold 16px/20px Montserrat;
                            letter-spacing: 0px;
                            color: #3A445E;
                            text-transform: uppercase;
                            margin-left: 10px;
                            opacity: 1;">Contexto Unidad Educativa</p>
                        </div>
                        <div class="col-sm-6" style="text-align: right;">

                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12">
                            <p style="text-align: left;font: normal normal bold 12px/19px Montserrat;letter-spacing: 0px; margin-left: 15px; color: #FF8685;text-transform: uppercase;opacity: 1;">Sello</p>
                        </div>
                    </div>
                    <div class="row" style="padding: 15px;">
                        <div class="col-sm-12">
                            <mat-form-field class="w-100" hintLabel="Max. 5000 caracteres">
                                <textarea
                                rows="8" 
                                cols="20" 
                                class="text-area-ideario" 
                                maxlength="5000"
                                autocomplete="off"
                                matInput
                                [disabled]="!guardarEditar"
                                id="sello"
                                name="sello"
                                (change)="change()"
                                [(ngModel)]="this.proyectoEducativoIdearioDataModel.sello"
                                ></textarea>
                                <mat-hint align="end">{{this.proyectoEducativoIdearioDataModel.sello.length || 0}}/5000</mat-hint>
                            </mat-form-field>  
                            <mat-error *ngIf="this.proyectoEducativoIdearioDataModel.sello.length>4999">Max. caracteres alcanzado</mat-error>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12">
                            <p style="text-align: left;font: normal normal bold 12px/19px Montserrat;letter-spacing: 0px; margin-left: 15px;color: #FF8685;text-transform: uppercase;opacity: 1;">Visión</p>
                        </div>
                    </div>
                    <div class="row" style="padding: 15px;">
                        <div class="col-sm-12">
                            <mat-form-field class="w-100" hintLabel="Max. 5000 caracteres">
                                <textarea
                                rows="8" 
                                cols="20" 
                                class="text-area-ideario" 
                                style="height: 50px;"
                                maxlength="5000"
                                autocomplete="off"
                                matInput
                                [disabled]="!guardarEditar"
                                id="vision"
                                name="vision"
                                (change)="change()"
                                [(ngModel)]="this.proyectoEducativoIdearioDataModel.vision"
                                ></textarea>
                                <mat-hint align="end">{{this.proyectoEducativoIdearioDataModel.vision.length || 0}}/5000</mat-hint>
                            </mat-form-field>  
                            <mat-error *ngIf="this.proyectoEducativoIdearioDataModel.vision.length>4999">Max. caracteres alcanzado</mat-error>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12">
                            <p style="text-align: left;font: normal normal bold 12px/19px Montserrat;letter-spacing: 0px; margin-left: 15px;color: #FF8685;text-transform: uppercase;opacity: 1;">Misión</p>
                        </div>
                    </div>
                    <div class="row" style="padding: 15px;">
                        <div class="col-sm-12">
                            <mat-form-field class="w-100" hintLabel="Max. 5000 caracteres">
                                <textarea
                                rows="8" 
                                cols="20" 
                                class="text-area-ideario" 
                                style="height: 88px;"
                                maxlength="5000"
                                autocomplete="off"
                                matInput
                                [disabled]="!guardarEditar"
                                id="mision"
                                name="mision"
                                (change)="change()"
                                [(ngModel)]="this.proyectoEducativoIdearioDataModel.mision"
                                ></textarea>
                                <mat-hint align="end">{{this.proyectoEducativoIdearioDataModel.mision.length || 0}}/5000</mat-hint>
                            </mat-form-field>  
                            <mat-error *ngIf="this.proyectoEducativoIdearioDataModel.mision.length>4999">Max. caracteres alcanzado</mat-error>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12">
                            <p style="text-align: left;font: normal normal bold 12px/19px Montserrat;letter-spacing: 0px; margin-left: 15px;color: #FF8685;text-transform: uppercase;opacity: 1;">Valores</p>
                        </div>
                    </div>
                    <div class="row" style="padding: 15px;">
                        <div class="col-sm-12">
                            <mat-form-field class="w-100" hintLabel="Max. 5000 caracteres">
                                <textarea
                                rows="8" 
                                cols="20" 
                                class="text-area-ideario" 
                                style="height: 130px;"
                                maxlength="5000"
                                autocomplete="off"
                                matInput
                                [disabled]="!guardarEditar"
                                id="valores"
                                name="valores"
                                (change)="change()"
                                [(ngModel)]="this.proyectoEducativoIdearioDataModel.valores"
                                ></textarea>
                                <mat-hint align="end">{{this.proyectoEducativoIdearioDataModel.valores.length || 0}}/5000</mat-hint>
                            </mat-form-field>  
                            <mat-error *ngIf="this.proyectoEducativoIdearioDataModel.valores.length>4999">Max. caracteres alcanzado</mat-error>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12">
                            <p style="text-align: left;font: normal normal bold 12px/19px Montserrat;letter-spacing: 0px; margin-left: 15px;color: #FF8685;text-transform: uppercase;opacity: 1;">Definiciones y sentidos institucionales</p>
                        </div>
                    </div>
                    <div class="row" style="padding: 15px;">
                        <div class="col-sm-12">
                            <mat-form-field class="w-100" hintLabel="Max. 8000 caracteres">
                                <textarea
                                rows="8" 
                                cols="20" 
                                class="text-area-ideario" 
                                style="height: 570px;"
                                maxlength="8000"
                                autocomplete="off"
                                matInput
                                [disabled]="!guardarEditar"
                                id="definiciones"
                                name="definiciones"
                                (change)="change()"
                                [(ngModel)]="this.proyectoEducativoIdearioDataModel.definiciones"
                                ></textarea>
                                <mat-hint align="end">{{this.proyectoEducativoIdearioDataModel.definiciones.length || 0}}/8000</mat-hint>
                            </mat-form-field>  
                            <mat-error *ngIf="this.proyectoEducativoIdearioDataModel.definiciones.length>7999">Max. caracteres alcanzado</mat-error>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12">
                            <p style="text-align: left;font: normal normal bold 12px/19px Montserrat;letter-spacing: 0px; margin-left: 15px;color: #FF8685;text-transform: uppercase;opacity: 1;">Perfiles</p>
                        </div>
                    </div>
                    <div class="row" style="padding: 15px;">
                        <div class="col-sm-12">
                            <mat-form-field class="w-100" hintLabel="Max. 8000 caracteres">
                                <textarea
                                rows="8" 
                                cols="20" 
                                class="text-area-ideario" 
                                style="height: 215px;"
                                maxlength="8000"
                                autocomplete="off"
                                matInput
                                [disabled]="!guardarEditar"
                                id="perfiles"
                                name="perfiles"
                                (change)="change()"
                                [(ngModel)]="this.proyectoEducativoIdearioDataModel.perfiles"
                                ></textarea>
                                <mat-hint align="end">{{this.proyectoEducativoIdearioDataModel.perfiles.length || 0}}/8000</mat-hint>
                            </mat-form-field>  
                            <mat-error *ngIf="this.proyectoEducativoIdearioDataModel.perfiles.length>7999">Max. caracteres alcanzado</mat-error>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    </div>
</div>